export default __webpack_public_path__ + "static/media/devlibre.e3d1a9ad.webp";